<template>
  <div class="home">
    <div class="header">
      <p>
        Welcome to SOS!
      </p>
    </div>
    <div class="content">
      <div class="body">
        <div class="section-1">
          <div class="info">
            Saviour of Savour(SOS) is an online food ordering and delivery
            platform developed by Jai and Chua for their Orbital Project. With
            this App, You can order food from your favorite Restaurants and
            Stalls present at various canteens around the NUS campus. You can
            also help save someones savour without the fuss of any registrations
            and earn some side cash to manage your tight budget. To become a
            saviour, all you have to do is confirm that you’re a student at NUS.
            Isn’t that great?
          </div>
          <div class="pic">
            <img class="main-logo" alt="SOS logo" src="../assets/SOSLogo.png" />
          </div>
        </div>

        <div class="log-in-or-register" v-if="!user">
          <div class="log-in" @click.prevent="userLogIn">
            Have an Account With Us? Log In Here...<Arrow class="arrow" />
          </div>
          <div class="register" @click.prevent="userRegister">
            New Here? Register With Us And Enjoy Your Favourite Food...<Arrow
              class="arrow"
            />
          </div>
        </div>

        <div class="logos">
          <div class="nus-logo">
            <img class="logo" alt="SOS logo" src="../assets/NUSLogo.png" />
          </div>
          <div class="loa-logo">
            <img class="logo" alt="SOS logo" src="../assets/Apollo11Logo.png" />
          </div>
          <div class="nodejs-logo">
            <img class="logo" alt="SOS logo" src="../assets/nodejsLogo.png" />
          </div>
          <div class="vuejs-logo">
            <img class="logo" alt="SOS logo" src="../assets/vueLogo.png" />
          </div>
          <div class="firebase-logo">
            <img class="logo" alt="SOS logo" src="../assets/firebaseLogo.png" />
          </div>
        </div>

        <div class="feedback">
          <p>
            <a
              href="https://forms.gle/ZcPcdkWkf1oZxtK9A"
              target="_blank"
              rel="noopener noreferrer"
              >Kindly Click Here And Provide Your Feedback After Navigating
              Around The App.
              <br />
              Thank You!</a
            >
          </p>
        </div>
      </div>
    </div>
    <!--
    <p>
      Welcome to SOS!
      <br />
      Website Under Construction
    </p>
    <img class="main-logo" alt="SOS logo" src="../assets/SOSLogo.png" />
    <div class="feedback">
      <p>
        <a
          href="https://forms.gle/ZcPcdkWkf1oZxtK9A"
          target="_blank"
          rel="noopener noreferrer"
          >Kindly Click Here And Provide Your Feedback After Navigating Around
          The App.
          <br />
          Thank You!</a
        >
      </p>
    </div>
    -->
  </div>
</template>

<script>
import Arrow from "../assets/Icons/arrow-right-light.svg";

export default {
  name: "Home",
  components: {
    Arrow,
  },
  methods: {
    userRegister() {
      this.$router.push({ name: "Register" });
    },
    userLogIn() {
      this.$router.push({ name: "Login" });
    },
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
  },
};
</script>

<style lang="scss" scoped>
.home {
  color: #fff;
  height: 920px;
  //height: 100vh;
  background-image: url("../assets/background/background5.jpeg");

  .header {
    p {
      font-size: 54px;
    }
  }

  .content {
    margin: 20px;
    padding: 20px;
    border-radius: 8px;
    background-color: rgba(0, 0, 0, 0);
    height: 75%;
    overflow: auto;

    &::-webkit-scrollbar {
      display: none;
    }

    .body {
      .section-1 {
        display: flex;
        flex-direction: column;

        @media (min-width: 800px) {
          flex-direction: row;
        }

        .info {
          flex-basis: 70%;
          font-size: 30px;
          background-color: rgba(0, 0, 0, 0.3);
          border-radius: 18px;
          padding: 15px;
        }

        .pic {
          flex-basis: 30%;
          margin: 20px auto;

          @media (min-width: 800px) {
            margin: 0 auto;
          }

          img {
            height: auto;
            width: 250px;
          }
        }
      }

      .log-in-or-register {
        font-weight: 500;
        .arrow {
          width: 12px;
          filter: invert(100%) sepia(1%) saturate(1010%) hue-rotate(115deg)
            brightness(115%) contrast(100%);
          margin: 0 0 0 0;
        }

        display: flex;
        flex-direction: column;
        margin: 20px auto;

        @media (min-width: 800px) {
          flex-direction: row;
        }

        .log-in {
          flex-basis: 50%;
          text-align: center;
          border-radius: 8px;
          background-color: rgba(0, 0, 0, 0.2);
          padding: 20px 10px;
          margin-bottom: 5px;
          transition: 0.5s;

          @media (min-width: 800px) {
            margin-right: 5px;
            margin-bottom: 0px;
          }

          &:hover {
            transition: 0.5s;
            cursor: pointer;
            background-color: rgba(0, 0, 0, 0.4);
          }
        }

        .register {
          flex-basis: 50%;
          text-align: center;
          border-radius: 8px;
          background-color: rgba(0, 0, 0, 0.2);
          padding: 20px 10px;
          margin-top: 5px;
          transition: 0.5s;

          @media (min-width: 800px) {
            margin-left: 5px;
            margin-top: 0px;
          }

          &:hover {
            transition: 0.5s;
            cursor: pointer;
            background-color: rgba(0, 0, 0, 0.4);
          }
        }
      }

      .logos {
        display: flex;
        flex-direction: column;
        justify-content: space-evenly;
        margin: 35px 0 10px 0;

        @media (min-width: 800px) {
          flex-direction: row;
        }

        img {
          height: 150px;
          width: 150px;
          border-radius: 0;
          transition: 0.4s;

          &:hover {
            transition: 0.4s;
            transform: rotateZ(0deg) scale(1.05);
          }
        }

        .nus-logo {
          img {
            height: 210px;
            width: 165px;
          }
        }

        .nodejs-logo {
          img {
            height: 180px;
          }
        }

        .firebase-logo {
          img {
            height: 180px;
            width: 120px;
          }
        }
      }
    }
  }

  .feedback {
    background-color: rgba(0, 0, 0, 0.5);
    border-radius: 8px;
    padding: 10px 8px;
    margin: 0 10px;

    a {
      text-decoration: none;
      color: #fff;
      font-size: 28px;
      font-weight: 500;
      transition: 0.25s;

      &:hover {
        color: #c8c8c8;
        transition: 0.25s;
      }
    }
  }

  p {
    text-align: center;
    font-size: 40px;
    padding: 20px;
    //background: -webkit-linear-gradient(rgb(109, 50, 169), rgb(210, 65, 188));
    //-webkit-background-clip: text;
    //-webkit-text-fill-color: transparent;
  }

  .main-logo {
    //margin-left: 500px;
    cursor: initial;
    height: 200px;
    width: 200px;
    border-radius: 30px;
    margin-left: auto;
    margin-right: auto;
    display: block;
  }
}
</style>
